import * as React from "react";

import { Link } from "gatsby";

// styles
const pageStyles = {
  color: "#232129",
  padding: 96,
  fontFamily: "-apple-system, Roboto, sans-serif, serif",
};
const headingStyles = {
  marginTop: 0,
  marginBottom: 64,
  maxWidth: 320,
};
const headingAccentStyles = {
  color: "#663399",
};
const paragraphStyles = {
  marginBottom: 48,
};
const codeStyles = {
  color: "#8A6534",
  padding: 4,
  backgroundColor: "#FFF4DB",
  fontSize: "1.25rem",
  borderRadius: 4,
};
const listStyles = {
  marginBottom: 96,
  paddingLeft: 0,
};
const listItemStyles = {
  fontWeight: 300,
  fontSize: 24,
  maxWidth: 560,
  marginBottom: 30,
};

const linkStyle = {
  color: "#8954A8",
  fontWeight: "bold",
  fontSize: 16,
  verticalAlign: "5%",
};

const docLinkStyle = {
  ...linkStyle,
  listStyleType: "none",
  marginBottom: 24,
};

const descriptionStyle = {
  color: "#232129",
  fontSize: 14,
  marginTop: 10,
  marginBottom: 0,
  lineHeight: 1.25,
};

const docLink = {
  text: "Documentation",
  url: "https://www.gatsbyjs.com/docs/",
  color: "#8954A8",
};

const badgeStyle = {
  color: "#fff",
  backgroundColor: "#088413",
  border: "1px solid #088413",
  fontSize: 11,
  fontWeight: "bold",
  letterSpacing: 1,
  borderRadius: 4,
  padding: "4px 6px",
  display: "inline-block",
  position: "relative",
  top: -2,
  marginLeft: 10,
  lineHeight: 1,
};

// data
const links = [
  {
    text: "3D-Globe Web",
    url: "https://globeearth.web.app/",
    badge: true,
    description:
      "An excellent zoom in and out feature. Simply click on a country and know the basic facts such as GDP, population, formal name, region, and sub-region. ",
    color: "#8EB814",
  },
  {
    text: "Support",
    url: "/support/",
    description:
      "Get in touch! We’d love to hear from you. Please don't hesitate to contact us about any questions or suggestions. ",
    color: "#E95800",
  },
  {
    text: "Terms and Conditions",
    url: "/terms/",
    description:
      "The terms and conditions-what you can expect from us as you use the app, and what we expect from you.",
    color: "#1099A8",
  },

  {
    text: "Privacy Policy",
    url: "/privacy/",
    description:
      "We take your privacy seriously. Please read the following to learn more about our privacy policy.",
    color: "#663399",
  },
  {
    text: "About Us",
    url: "/about/",
    description:
      "GlobalOpsNAV is not only an app, but it is an idea whose time has come! ",
    color: "#0D96F2",
  },
];

// markup
const IndexPage = () => {
  return (
    <main style={pageStyles}>
      <title>About Us</title>
      <h1 style={headingStyles}>GlobalOpsNAV</h1>
      <p style={paragraphStyles}>
        The ULTIMATE Global Operation’s app. The app you’ve always wanted. It
        serves as a step-by-step guide to the world of global operations
        designed to help the corporate, higher education and the not-for-profit
        organizations.
      </p>
      <ul style={listStyles}>
        {links.map((link) => (
          <li key={link.url} style={{ ...listItemStyles, color: link.color }}>
            <span>
              <Link
                style={linkStyle}
                to={`${link.url}?utm_source=starter&utm_medium=start-page&utm_campaign=minimal-starter`}
              >
                {link.text}
              </Link>
              {link.badge && (
                <span style={badgeStyle} aria-label="New Badge">
                  NEW!
                </span>
              )}
              <p style={descriptionStyle}>{link.description}</p>
            </span>
          </li>
        ))}
      </ul>
      <img
        alt="Gatsby G Logo"
        src="data:image/svg+xml,%3Csvg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 2a10 10 0 110 20 10 10 0 010-20zm0 2c-3.73 0-6.86 2.55-7.75 6L14 19.75c3.45-.89 6-4.02 6-7.75h-5.25v1.5h3.45a6.37 6.37 0 01-3.89 4.44L6.06 9.69C7 7.31 9.3 5.63 12 5.63c2.13 0 4 1.04 5.18 2.65l1.23-1.06A7.959 7.959 0 0012 4zm-8 8a8 8 0 008 8c.04 0 .09 0-8-8z' fill='%23639'/%3E%3C/svg%3E"
      />
    </main>
  );
};

export default IndexPage;
